<script>
import { required } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables';
import { useI18n } from 'vue-i18n';
import { ref, computed } from 'vue';
import { useStore } from 'dashboard/composables/store';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: { NextButton },
  props: {
    selectedKnowledgebase: {
      type: Object,
      default: () => {},
    },
  },
  setup(props, { emit }) {
    const rules = {
      url: { required },
    };

    const { t } = useI18n();
    const store = useStore();
    const url = ref('');
    const v$ = useVuelidate(rules, { url });

    const uiFlags = computed(() => store.getters['records/getUIFlags']);
    const pageTitle = computed(() => t('LIBRARIES.SITES.TITLE'));

    const onClose = () => {
      emit('on-close');
    };

    const addRecord = async () => {
      v$.value.$touch();
      if (v$.value.$invalid) {
        return;
      }
      try {
        await store.dispatch('records/create', {
          knowledgebaseId: props.selectedKnowledgebase.id,
          record: { source: url.value },
        });
        useAlert(t('LIBRARIES.RECORDS.API.SUCCESS_MESSAGE'));
        onClose();
      } catch (error) {
        useAlert(t('LIBRARIES.RECORDS.API.ERROR_MESSAGE'));
      }
    };

    return {
      v$,
      url,
      uiFlags,
      pageTitle,
      onClose,
      addRecord,
    };
  },
  mounted() {
    this.$nextTick(() => {
      const el = this.$refs.firstInput?.$el?.querySelector?.('input');
      if (el) el.focus();
    });
  },
};
</script>

<template>
  <div class="h-auto overflow-auto flex flex-col">
    <woot-modal-header :header-title="pageTitle" />

    <form
      class="flex flex-col w-full"
      @submit.prevent="addRecord"
      @keydown.enter.prevent="addRecord"
    >
      <div class="w-full">
        <woot-input
          ref="firstInput"
          v-model="url"
          :label="$t('LIBRARIES.SITES.ADD_PAGE.FORM.URL.LABEL')"
          type="text"
          class="mb-0"
          :class="{ error: v$.url.$error }"
          :error="
            v$.url.$error ? $t('LIBRARIES.SITES.ADD_PAGE.FORM.URL.ERROR') : ''
          "
          :placeholder="$t('LIBRARIES.SITES.ADD_PAGE.FORM.URL.PLACEHOLDER')"
          @blur="v$.url.$touch"
        />
      </div>
      <div class="flex flex-row justify-end gap-2 py-2 px-0 w-full">
        <NextButton
          :label="$t('LIBRARIES.SITES.CANCEL_BUTTON_TEXT')"
          md
          slate
          ghost
          @click.prevent="onClose"
        />
        <NextButton
          type="submit"
          :is-loading="uiFlags.isCreating"
          :label="$t('LIBRARIES.SITES.CREATE_BUTTON_TEXT')"
        />
      </div>
    </form>
  </div>
</template>

<style lang="scss" scoped>
::v-deep .ProseMirror-woot-style {
  height: 5rem;
}
</style>
